import React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useChatContext } from "./chat_context.jsx";

export default function ChatHistorySidebar() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const { t } = useTranslation("labels");
  
  const {
    showHistorySidebar,
    setShowHistorySidebar,
    chatHistoryNodes,
    headerHeight: contextHeaderHeight,
  } = useChatContext();

  useEffect(() => {
    const calculateHeaderHeight = () => {
      const header = document.querySelector(".header");
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    calculateHeaderHeight();
    window.addEventListener("resize", calculateHeaderHeight);

    return () => {
      window.removeEventListener("resize", calculateHeaderHeight);
    };
  }, []);

  return (
    <>
      <div
        className={`position-fixed d-flex flex-column bg-white border-start border-secondary shadow ${showHistorySidebar ? "end-0" : "end-n5"}`}
        style={{
          top: `${headerHeight}px`,
          height: `calc(100vh - ${headerHeight}px)`,
          width: "350px",
          zIndex: 1051,
          transition: "right 0.3s ease-in-out",
          right: showHistorySidebar ? "0" : "-350px"
        }}
      >
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
          <h5 className="mb-0">{t("pastChats", { ns: "labels" })}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowHistorySidebar(false)}
            aria-label="Close"
          ></button>
        </div>
        <div className="flex-grow-1" style={{ overflowY: "auto" }}>
          <div className="p-3">
            {chatHistoryNodes.folders.length > 0 && (
              <>
                <h6>
                  <i className="fa-solid fa-folder me-2"></i>
                  {t("folders", { ns: "labels" })}
                </h6>
                <ul className="list-unstyled mb-4">
                  {chatHistoryNodes.folders.map((folder) => (
                    <li key={folder.Id} className="mb-2">
                      <a
                        href={`/dms/chat/folder/${folder.Id}`}
                        className="text-decoration-none text-dark d-block p-2 rounded"
                        style={{ transition: "background-color 0.2s" }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = "#f1f1f1"}
                        onMouseLeave={(e) => e.target.style.backgroundColor = ""}
                      >
                        {folder.Name}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}
            {chatHistoryNodes.files.length > 0 && (
              <>
                <h6>
                  <i className="fa-solid fa-file-alt me-2"></i>
                  {t("files", { ns: "labels" })}
                </h6>
                <ul className="list-unstyled">
                  {chatHistoryNodes.files.map((file) => (
                    <li key={file.Id} className="mb-2">
                      <a
                        href={`/dms/chat/${file.Id}`}
                        className="text-decoration-none text-dark d-block p-2 rounded"
                        style={{ transition: "background-color 0.2s" }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = "#f1f1f1"}
                        onMouseLeave={(e) => e.target.style.backgroundColor = ""}
                      >
                        {file.Name}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}
            {chatHistoryNodes.files.length === 0 &&
              chatHistoryNodes.folders.length === 0 && (
                <p className="text-muted">
                  {t("noPastChats", { ns: "labels" })}
                </p>
              )}
          </div>
        </div>
      </div>
      {showHistorySidebar && (
        <div
          className="modal-backdrop fade show"
          onClick={() => setShowHistorySidebar(false)}
          style={{ zIndex: 1050, display: "none" }}
        ></div>
      )}
    </>
  );
}


